import React, { useState } from "react";
import { auth, db } from "../lib/firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { Modal, toast } from "./UI";

export default function CreateCustomerModal({ onClose, onSaved }) {
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError]   = useState("");
  const [saving, setSaving] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const save = async () => {
    if (!form.name || !form.email || !form.password) {
      setError("All fields are required."); return;
    }
    if (form.password.length < 6) {
      setError("Password must be at least 6 characters."); return;
    }

    setSaving(true); setError("");
    try {
      // Create Firebase Auth account
      const cred = await createUserWithEmailAndPassword(auth, form.email, form.password);

      // Save profile to Firestore
      await setDoc(doc(db, "users", cred.user.uid), {
        email:     form.email.toLowerCase().trim(),
        name:      form.name.trim(),
        role:      "customer",
        createdAt: serverTimestamp(),
      });

      toast(`Customer account created for ${form.name}!`);
      onSaved();
      onClose();
    } catch (e) {
      if (e.code === "auth/email-already-in-use") {
        setError("This email is already registered.");
      } else if (e.code === "auth/invalid-email") {
        setError("Please enter a valid email address.");
      } else {
        setError(e.message);
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal title="Create customer account" onClose={onClose} maxWidth={420}>
      {error && <div className="error-msg">{error}</div>}
      <p style={{ fontSize: 13, color: "var(--text-muted)", marginBottom: 16 }}>
        This creates a login account for your customer. Share the email and password with them so they can sign in and view their packages.
      </p>
      <div className="form-row">
        <label>Full name *</label>
        <input
          placeholder="John Doe"
          value={form.name}
          onChange={e => set("name", e.target.value)}
        />
      </div>
      <div className="form-row">
        <label>Email address *</label>
        <input
          type="email"
          placeholder="customer@example.com"
          value={form.email}
          onChange={e => set("email", e.target.value)}
        />
      </div>
      <div className="form-row">
        <label>Password *</label>
        <input
          type="password"
          placeholder="Min. 6 characters"
          value={form.password}
          onChange={e => set("password", e.target.value)}
        />
      </div>
      <div className="success-msg" style={{ marginBottom: 0 }}>
        💡 After creating the account, share the email and password with your customer so they can log in.
      </div>
      <div className="modal-footer" style={{ marginTop: 16 }}>
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary" onClick={save} disabled={saving}>
          {saving ? "Creating…" : "Create account"}
        </button>
      </div>
    </Modal>
  );
}
